import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useStore } from "vuex";
import { customInstance, type ErrorType } from "@/custom-axios";
import { IS_AUTH_BUILD_TARGET } from "@/config";
import { publicTenantSettingsQueryKey } from "./queryKeys";
import type { TenantSettingsForPublic } from "./types";

// Legacy public endpoint — available without authentication.
// Used for pre-login screens (e.g. parent registration) that need a subset of settings.
const getPublicTenantSettings = async (): Promise<TenantSettingsForPublic> => {
  const response = await customInstance<{ data: TenantSettingsForPublic }>(
    "/api/frontend/common/settings/public",
    { method: "GET" },
  );
  return response.data;
};

export function usePublicTenantSettings(options?: { forceEnabled?: boolean }) {
  const store = useStore();
  const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"] as boolean);

  return useQuery<TenantSettingsForPublic, ErrorType<unknown>>({
    queryKey: publicTenantSettingsQueryKey(),
    queryFn: getPublicTenantSettings,
    enabled: computed(
      () => (options?.forceEnabled || !isAuthenticated.value) && !IS_AUTH_BUILD_TARGET,
    ),
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
